<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Plot Rent Register</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />
    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- Start right Content here -->
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Plot Rent Register</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Revenue</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Plot Rent Register</a></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Enhanced Administrative Tools Section -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-success text-white">
                  <h5 class="mb-0 text-white">
                    <i class="mdi mdi-calculator-variant me-2"></i>
                    Penalty & Billing Management
                  </h5>
                </div>
                <div class="card-body">

                  <div class="row align-items-center">
                    <!-- Annual Rent Billing -->
                    <div class="col-md-3 mb-3" v-if="getRight('PLOTRENT BILL ANNUAL')">
                      <div class="d-grid">
                        <button
                            @click="showBillAnnualRentModal"
                            :disabled="processingBilling"
                            class="btn btn-primary btn-lg">
                          <i class="mdi mdi-calendar-clock me-2"></i>
                          <span v-if="processingBilling">Processing...</span>
                          <span v-else>Bill Annual Rent</span>
                        </button>
                        <small class="text-muted mt-1">Bill annual rent for fiscal year</small>
                      </div>
                    </div>

                    <!-- Annual Penalty -->
                    <div class="col-md-3 mb-3" v-if="getRight('PLOTRENT CALCULATE PENALTY')">
                      <div class="d-grid">
                        <button
                            @click="calculateAnnualPenalty"
                            :disabled="processingPenalty"
                            class="btn btn-danger btn-lg">
                          <i class="mdi mdi-alert-octagon me-2"></i>
                          <span v-if="processingPenalty">Processing...</span>
                          <span v-else>Calculate 25% Annual Penalty</span>
                        </button>
                        <small class="text-muted mt-1">Apply 25% penalty on rent arrears</small>
                      </div>
                    </div>

                    <!-- Process Payment -->
<!--                    <div class="col-md-3 mb-3" v-if="getRight('PLOTRENT PROCESS PAYMENT')">
                      <div class="d-grid">
                        <button
                            data-bs-toggle="modal"
                            data-bs-target=".payment-processing-modal"
                            class="btn btn-success btn-lg">
                          <i class="mdi mdi-cash-multiple me-2"></i>
                          Process Payment
                        </button>
                        <small class="text-muted mt-1">Apply payment with arrears-first logic</small>
                      </div>
                    </div>-->

                    <!-- Arrears Report -->
                    <div class="col-md-3 mb-3" v-if="getRight('PLOTRENT ARREARS REPORT')">
                      <div class="d-grid">
                        <button
                            data-bs-toggle="modal"
                            data-bs-target=".arrears-report-modal"
                            class="btn btn-info btn-lg">
                          <i class="mdi mdi-file-chart me-2"></i>
                          Arrears Report
                        </button>
                        <small class="text-muted mt-1">Generate zone arrears summary</small>
                      </div>
                    </div>
                  </div>

                  <!-- Processing Status -->
                  <div v-if="processingStatus" class="alert alert-info mt-3">
                    <div class="d-flex align-items-center">
                      <div class="spinner-border spinner-border-sm text-info me-3" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <div>
                        <strong>{{ processingStatus.title }}</strong>
                        <div class="mt-1">{{ processingStatus.message }}</div>
                      </div>
                    </div>
                  </div>

                  <!-- Last Processing Summary -->
                  <div v-if="lastProcessingSummary" class="mt-3">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="card border-success">
                          <div class="card-body p-3">
                            <h6 class="card-title text-success mb-2">
                              <i class="mdi mdi-check-circle me-1"></i>
                              Last Billing Summary
                            </h6>
                            <div class="row text-center">
                              <div class="col-6">
                                <div class="fw-bold text-primary">{{ lastProcessingSummary.billing?.plotsProcessed || 0 }}</div>
                                <small class="text-muted">Plots Billed</small>
                              </div>
                              <div class="col-6">
                                <div class="fw-bold text-success">KES {{ numberFormat(lastProcessingSummary.billing?.totalBilled || 0) }}</div>
                                <small class="text-muted">Total Billed</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="card border-warning">
                          <div class="card-body p-3">
                            <h6 class="card-title text-warning mb-2">
                              <i class="mdi mdi-alert-circle me-1"></i>
                              Last Penalty Summary
                            </h6>
                            <div class="row text-center">
                              <div class="col-6">
                                <div class="fw-bold text-primary">{{ lastProcessingSummary.penalty?.plotsProcessed || 0 }}</div>
                                <small class="text-muted">Plots</small>
                              </div>
                              <div class="col-6">
                                <div class="fw-bold text-warning">KES {{ numberFormat(lastProcessingSummary.penalty?.totalPenaltyApplied || 0) }}</div>
                                <small class="text-muted">Penalty Applied</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 px-sm-30px">
              <div class="card">
                <div class="card-header bg-white w-100 border-bottom d-flex justify-content-between align-items-center">
                  <h4 class="card-title text-capitalize">Plot Rent Register</h4>

                  <div class="d-flex">
                    <button v-if="getRight('PLOTRENT ADD PLOT')" data-bs-toggle="modal" data-bs-target=".add-plot-modal" type="button" class="btn btn-success text-uppercase dropdown-toggle option-selector me-3">
                      <i class="bx bx-plus font-size-16"></i> <span class="pl-1 d-md-inline">Add Plot</span>
                    </button>

                    <button v-if="getRight('PLOTRENT UPLOAD SHEET')" data-bs-toggle="modal" data-bs-target=".upload-plot-modal" type="button" class="btn btn-info text-uppercase dropdown-toggle option-selector me-3">
                      <i class="mdi mdi-file-document-outline font-size-16"></i> <span class="pl-1 d-md-inline">Upload Sheet</span>
                    </button>

                    <button v-if="getRight('PLOTRENT MANAGE ZONES')" data-bs-toggle="modal" data-bs-target=".manage-zones-modal" type="button" class="btn btn-secondary text-uppercase dropdown-toggle option-selector me-3">
                      <i class="mdi mdi-map-marker-multiple font-size-16"></i> <span class="pl-1 d-md-inline">Manage Zones</span>
                    </button>
                  </div>
                </div>

                <!-- Search section -->
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input v-model="keyword" type="text" class="form-control bg-light border-light rounded" placeholder="Search by plot number, owner name, phone..." spellcheck="false">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Filters section -->
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="d-flex flex-wrap">
                      <select class="form-select w-auto font-13px mx-3" v-model="subCounty">
                        <option value="">All Sub Counties</option>
                        <option :key="index" :value="item" v-for="(item, index) in subCounties">
                          {{ item.subCountyName }}
                        </option>
                      </select>

                      <select class="form-select w-auto font-13px mx-3" v-model="ward">
                        <option value="">All Wards</option>
                        <option :key="index" :value="item" v-for="(item, index) in wards">
                          {{ item.wardName }}
                        </option>
                      </select>

                      <select class="form-select w-auto font-13px mx-3" v-model="selectedZone">
                        <option value="">All Zones/Markets</option>
                        <option :key="index" :value="item.zone" v-for="(item, index) in zones">
                          {{ item.zone }}
                        </option>
                      </select>

                      <select class="form-select w-auto font-13px mx-3" v-model="selectedStatus">
                        <option value="">All Status</option>
                        <option value="Active">Active</option>
                        <option value="Vacant">Vacant</option>
                        <option value="Suspended">Suspended</option>
                        <option value="Transferred">Transferred</option>
                      </select>

                      <!-- Download Buttons -->
                      <div class="btn-group me-3" role="group">
                        <button
                            @click="downloadCurrentPage()"
                            type="button"
                            class="btn btn-success"
                            :disabled="plots.length === 0">
                          <i class="bx bxs-download font-size-16"></i>
                          <span class="ms-1">Current Page</span>
                        </button>

                        <button
                            @click="downloadAllRecords()"
                            type="button"
                            class="btn btn-primary"
                            :disabled="isDownloadingAll || summary.totalPlots === 0">
                          <span v-if="isDownloadingAll">
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Downloading...
                          </span>
                          <span v-else>
                            <i class="bx bxs-cloud-download font-size-16"></i>
                            <span class="ms-1">All ({{ numberFormat(summary.totalPlots || 0) }})</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Main data table -->
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-middle table-striped table-nowrap table-hover dt-responsive contacts-table">
                      <thead class="table-dark">
                      <tr>
                        <th scope="col">Plot Number</th>
                        <th>Zone/Market</th>
                        <th>Owner Details</th>
                        <th>Location</th>
                        <th>Annual Rent</th>
                        <th>Arrears B/F</th>
                        <th>Total Billed</th>
                        <th>Accumulated Penalty</th>
                        <th>Total Payments</th>
                        <th>Current Balance</th>
                        <th>Status</th>
                        <th>Last Payment</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody class="text-capitalize">
                      <tr :key="index" v-for="(item, index) in plots">
                        <!-- Plot Number -->
                        <td style="min-width: 120px;">
                          <div class="d-flex flex-column">
                            <strong class="text-primary">{{ item.plotNumber }}</strong>
                            <small class="text-muted">ID: {{ item.id }}</small>
                          </div>
                        </td>

                        <!-- Zone/Market -->
                        <td style="min-width: 140px;">
                          <span class="badge bg-info">{{ item.zone }}</span>
                        </td>

                        <!-- Owner Details -->
                        <td style="min-width: 200px;">
                          <div>
                            <strong>{{ item.ownerNames }}</strong>
                            <div v-if="item.ownerPhoneNo" class="text-muted small mt-1">
                              <i class="bx bx-phone text-success"></i> {{ maskPhoneNumber(item.ownerPhoneNo) }}
                            </div>
                            <div v-if="item.ownerID" class="text-muted small">
                              <i class="bx bx-id-card text-primary"></i> {{ item.ownerID }}
                            </div>
                            <div v-if="item.ownerEmail" class="text-muted small">
                              <i class="bx bx-envelope text-primary"></i> {{ item.ownerEmail }}
                            </div>
                          </div>
                        </td>

                        <!-- Location -->
                        <td style="min-width: 180px;">
                          <div>
                            <div class="fw-bold">{{ item.subCountyName }}</div>
                            <div v-if="item.wardName" class="text-muted small">Ward: {{ item.wardName }}</div>
                            <div v-if="item.plotAddress" class="text-muted small">
                              <i class="bx bx-map-pin text-warning"></i> {{ item.plotAddress }}
                            </div>
                          </div>
                        </td>

                        <!-- Annual Rent -->
                        <td style="min-width: 120px;">
                          <div class="text-end">
                            <div class="fw-bold text-success">
                              KES {{ numberFormat(item.annualRent || 0) }}
                            </div>
                            <small class="text-muted">Per Year</small>
                          </div>
                        </td>

                        <!-- Arrears B/F -->
                        <td style="min-width: 120px;">
                          <div class="text-end">
                            <div class="fw-bold" :class="item.arrearsForward > 0 ? 'text-danger' : 'text-muted'">
                              KES {{ numberFormat(item.arrearsForward || 0) }}
                            </div>
                            <small class="text-muted">Arrears B/F</small>
                          </div>
                        </td>

                        <!-- Total Billed -->
                        <td style="min-width: 120px;">
                          <div class="text-end">
                            <div class="fw-bold text-info">
                              KES {{ numberFormat(item.totalBilled || 0) }}
                            </div>
                            <small class="text-muted">Billed</small>
                          </div>
                        </td>

                        <!-- Accumulated Penalty -->
                        <td style="min-width: 110px;">
                          <div class="text-end">
                            <div class="fw-bold" :class="item.accumulatedPenalty > 0 ? 'text-warning' : 'text-muted'">
                              KES {{ numberFormat(item.accumulatedPenalty || 0) }}
                            </div>
                            <small class="text-muted">Penalty</small>
                          </div>
                        </td>

                        <!-- Total Payments -->
                        <td style="min-width: 120px;">
                          <div class="text-end">
                            <div class="fw-bold text-primary">
                              KES {{ numberFormat(item.totalPayments || 0) }}
                            </div>
                            <small class="text-muted">Paid</small>
                          </div>
                        </td>

                        <!-- Current Balance -->
                        <td style="min-width: 120px;">
                          <div class="text-end">
                            <div class="fw-bold" :class="item.currentBalance > 0 ? 'text-danger' : 'text-success'">
                              KES {{ numberFormat(item.currentBalance || 0) }}
                            </div>
                          </div>
                        </td>

                        <!-- Status -->
                        <td style="min-width: 100px;">
                          <div class="text-center">
                            <span v-if="item.status === 'Active'" class="badge rounded-pill bg-success text-uppercase">Active</span>
                            <span v-else-if="item.status === 'Vacant'" class="badge rounded-pill bg-secondary text-uppercase">Vacant</span>
                            <span v-else-if="item.status === 'Suspended'" class="badge rounded-pill bg-danger text-uppercase">Suspended</span>
                            <span v-else-if="item.status === 'Transferred'" class="badge rounded-pill bg-info text-uppercase">Transferred</span>
                            <span v-else class="badge rounded-pill bg-secondary text-uppercase">{{ item.status || 'Active' }}</span>
                          </div>
                        </td>

                        <!-- Last Payment -->
                        <td style="min-width: 100px;">
                          <div class="text-center">
                            <span v-if="item.lastPaymentDate">{{ formatDate(item.lastPaymentDate) }}</span>
                            <span v-else class="text-muted">-</span>
                          </div>
                        </td>

                        <!-- Actions -->
                        <td style="min-width: 140px;">
                          <div class="dropdown">
                            <button role="button" data-bs-toggle="dropdown" aria-haspopup="true" class="btn btn-sm btn-warning text-black waves-effect btn-label waves-light text-uppercase">
                              <i class="mdi mdi-arrow-down-drop-circle label-icon"></i> Options
                            </button>

                            <div class="dropdown-menu dropdown-menu-end">

                              <a v-if="getRight('PLOTRENT VIEW DETAILS')" @click="selectPlot(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".plot-details-modal">
                                <i class="font-size-15 mdi mdi-eye-plus-outline me-3"></i>Plot Details
                              </a>

                              <a v-if="getRight('PLOTRENT BILL CLIENT')" @click="openBillingModal(item)" class="dropdown-item" href="javascript: void(0);">
                                <i class="font-size-15 mdi mdi-receipt me-3"></i>Bill Client
                              </a>

                              <a v-if="getRight('PLOTRENT PROCESS PAYMENT')" @click="selectPlotForPayment(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".payment-processing-modal">
                                <i class="font-size-15 mdi mdi-cash-multiple me-3 text-success"></i>Process Payment
                              </a>

                              <a v-if="getRight('PLOTRENT STATEMENTS')" @click="goToStatements(item)" class="dropdown-item" href="javascript: void(0);">
                                <i class="font-size-15 mdi mdi-microsoft-excel me-3"></i>Statements
                              </a>

                              <a v-if="getRight('PLOTRENT EDIT')" @click="openEditModal(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".edit-plot-modal">
                                <i class="font-size-15 mdi mdi-file-document-edit me-3"></i>Edit Plot
                              </a>

                              <a v-if="getRight('PLOTRENT TRANSFER')" @click="selectPlot(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".transfer-modal">
                                <i class="font-size-15 mdi mdi-transfer me-3"></i>Transfer
                              </a>

                              <a v-if="item.status !== 'Suspended' && getRight('PLOTRENT SUSPEND')" @click="handleSuspendPlot(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".suspend-modal">
                                <i class="font-size-15 mdi mdi-lock me-3 text-danger"></i>Suspend
                              </a>

                              <a v-if="item.status === 'Suspended' && getRight('PLOTRENT REINSTATE')" @click="handleReinstatePlot(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".reinstate-modal">
                                <i class="font-size-15 mdi mdi-lock-open-outline me-3 text-success"></i>Reinstate
                              </a>

                              <a v-if="item.status !== 'Vacant' && getRight('PLOTRENT VACATE')" @click="handleVacatePlot(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".vacate-modal">
                                <i class="font-size-15 mdi mdi-home-remove me-3 text-warning"></i>Mark as Vacant
                              </a>

                              <a v-if="getRight('PLOTRENT DELETE')" @click="deletePlot(item)" class="dropdown-item">
                                <i class="font-size-15 mdi mdi-delete-alert me-3 text-danger"></i>Delete
                              </a>

                              <a v-if="getRight('PLOTRENT DEMAND NOTICE')" @click="selectPlot(item)" class="dropdown-item" href="javascript: void(0);" data-bs-toggle="modal" data-bs-target=".demand-notice-modal">
                                <i class="font-size-15 mdi mdi-alert-outline me-3 text-danger"></i>Send Demand Notice
                              </a>

                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>

                      <!-- Footer with totals -->
                      <tfoot class="table-dark">
                      <tr>
                        <th>{{ plots.length }} Plots</th>
                        <th></th>
                        <th>
                          <span class="badge rounded-pill bg-success text-uppercase me-1">{{ totalActive }}</span>
                          <span class="badge rounded-pill bg-danger text-uppercase">{{ totalSuspended }}</span>
                        </th>
                        <th></th>
                        <th class="text-end">
                          <div class="fw-bold">KES {{ numberFormat(totalAnnualRent) }}</div>
                          <small>Total Annual</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold text-danger">KES {{ numberFormat(totalArrears) }}</div>
                          <small>Total Arrears</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold text-info">KES {{ numberFormat(totalBilled) }}</div>
                          <small>Total Billed</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold text-warning">KES {{ numberFormat(totalPenalty) }}</div>
                          <small>Total</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold text-primary">KES {{ numberFormat(totalPayments) }}</div>
                          <small>Total Paid</small>
                        </th>
                        <th class="text-end">
                          <div class="fw-bold">KES {{ numberFormat(totalBalance) }}</div>
                          <small>Total Balance</small>
                        </th>
                        <th colspan="3"></th>
                      </tr>
                      </tfoot>
                    </table>

                    <!-- Loading state -->
                    <div class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center d-flex justify-content-center" v-if="loading">
                      <div class="p-5 py-0 pt-3">
                        <div class="p-5">
                          <div class="spinner-border text-info m-1" role="status">
                            <span class="sr-only text-uppercase">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <h4 class="text-uppercase">Loading Data</h4>
                      <div class="col-sm-12 col-md-8 col-lg-5">
                        <p>We are fetching the data for you. It will be ready soon. Please wait and have fun. Thank you for your interest.</p>
                      </div>
                    </div>

                    <!-- No results state -->
                    <div class="card-body d-sm-none d-md-block px-5 d-flex flex-column justify-items-center align-items-center text-center" v-if="plots.length < 1 && loading === false">
                      <div class="p-5 py-0 pt-3">
                        <img :src="'./assets/images/no-results.png'" alt="No search results" class="img mb-4"/>
                      </div>
                      <h4>No Results To Show</h4>
                      <p>Sorry, we could not find any results that match your search or filter criteria. Please try using different keywords or filters.</p>
                    </div>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation example" class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <span class="pr-3 pb-0 mb-0 font-13px">
                          <span>Rows Per Page</span>
                        </span>
                      <select class="form-select w-auto font-13px" v-model="pageSize">
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                        <option value="150">150 Rows</option>
                        <option value="200">200 Rows</option>
                      </select>
                    </div>

                    <ul class="pagination">
                      <li :class="{ disabled: currentPage === 1 }" class="page-item">
                        <a :disabled="currentPage === 1" @click="prevPage" class="page-link" tabindex="-1">Previous</a>
                      </li>
                      <li :class="{ active: currentPage === page }" :key="page" class="page-item" v-for="page in pagination(currentPage, totalPages, 3)">
                        <span class="page-link" v-if="page === '...'">{{ page }}</span>
                        <a @click="goToPage(page)" class="page-link" v-else>{{ page }}</a>
                      </li>
                      <li :class="{ disabled: currentPage === totalPages }" class="page-item">
                        <a :disabled="currentPage === totalPages" @click="nextPage" class="page-link">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Payment Processing Modal -->
      <div class="modal fade payment-processing-modal" tabindex="-1" role="dialog" aria-labelledby="paymentProcessingModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-success text-white">
              <h5 class="modal-title text-white" id="paymentProcessingModalLabel">
                <i class="mdi mdi-cash-multiple me-2"></i>
                Process Payment - Arrears First Priority
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <!-- Plot Information -->
              <div v-if="selectedPlotForPayment" class="card mb-4">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Plot Details</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <strong>Plot Number:</strong> {{ selectedPlotForPayment.plotNumber }}<br>
                      <strong>Owner:</strong> {{ selectedPlotForPayment.ownerNames }}<br>
                      <strong>Zone:</strong> {{ selectedPlotForPayment.zone }}
                    </div>
                    <div class="col-md-6">
                      <strong>Current Balance:</strong> <span class="text-danger">KES {{ numberFormat(selectedPlotForPayment.currentBalance || 0) }}</span><br>
                      <strong>Arrears B/F:</strong> KES {{ numberFormat(selectedPlotForPayment.arrearsForward || 0) }}<br>
                      <strong>Accumulated Penalty:</strong> KES {{ numberFormat(selectedPlotForPayment.accumulatedPenalty || 0) }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Payment Form -->
              <div class="card">
                <div class="card-header bg-info text-white">
                  <h6 class="mb-0 text-white">Payment Information</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">Payment Amount *</label>
                        <input v-model="paymentForm.amount" type="number" step="0.01" class="form-control" placeholder="Enter payment amount" required>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Payment Mode *</label>
                        <select v-model="paymentForm.paymentMode" class="form-select" required>
                          <option value="">Select Payment Mode</option>
                          <option value="CASH">Cash</option>
                          <option value="MPESA">M-Pesa</option>
                          <option value="BANK">Bank Transfer</option>
                          <option value="CHEQUE">Cheque</option>
                        </select>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Transaction Code</label>
                        <input v-model="paymentForm.transactionCode" type="text" class="form-control" placeholder="Enter transaction reference">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">Paid By</label>
                        <input v-model="paymentForm.paidBy" type="text" class="form-control" placeholder="Name of person making payment">
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Phone Number</label>
                        <input v-model="paymentForm.phoneNumber" type="text" class="form-control" placeholder="Phone number">
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Fiscal Year</label>
                        <select v-model="paymentForm.fiscalYear" class="form-select">
                          <option :value="currentFiscalYear">{{ currentFiscalYear }}</option>
                          <option :value="currentFiscalYear - 1">{{ currentFiscalYear - 1 }}</option>
                          <option :value="currentFiscalYear - 2">{{ currentFiscalYear - 2 }}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Payment Priority Information -->
                  <div class="alert alert-info mt-3">
                    <h6><i class="mdi mdi-information me-2"></i>Payment Allocation Priority:</h6>
                    <ol class="mb-0">
                      <li><strong>Oldest Fiscal Year First</strong> - Arrears from previous years</li>
                      <li><strong>Annual Rent</strong> - Current year charges</li>
                      <li><strong>Penalties</strong> - 25% penalty on unpaid arrears</li>
                    </ol>
                    <small class="text-muted mt-2 d-block">Payment will be allocated to the oldest outstanding balance first.</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button @click="processPayment" type="button" class="btn btn-success" :disabled="processingPayment">
                <span v-if="processingPayment">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Processing...
                </span>
                <span v-else>
                  <i class="mdi mdi-cash-check me-2"></i>
                  Process Payment
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Arrears Report Modal -->
      <div class="modal fade arrears-report-modal" tabindex="-1" role="dialog" aria-labelledby="arrearsReportModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-info text-white">
              <h5 class="modal-title text-white" id="arrearsReportModalLabel">
                <i class="mdi mdi-file-chart me-2"></i>
                Arrears Report by Zone
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <!-- Report Filters -->
              <div class="card mb-4">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Report Filters</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-label">Report Type</label>
                      <select v-model="arrearsReportForm.reportType" @change="generateArrearsReport" class="form-select">
                        <option value="zone">By Zone/Market</option>
                        <option value="subcounty">By Sub-County</option>
                        <option value="ward">By Ward</option>
                      </select>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label">Sub-County</label>
                      <select v-model="arrearsReportForm.subCountyID" @change="generateArrearsReport" class="form-select">
                        <option value="">All Sub-Counties</option>
                        <option :value="item.subCountyID" v-for="item in subCounties" :key="item.subCountyID">
                          {{ item.subCountyName }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4">
                      <button @click="generateArrearsReport" class="btn btn-primary mt-4">
                        <i class="mdi mdi-refresh me-2"></i>Generate Report
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Report Results -->
              <div v-if="arrearsReportData && arrearsReportData.length > 0" class="card">
                <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
                  <h6 class="mb-0 text-white">Arrears Summary</h6>
                  <button @click="downloadArrearsReport" class="btn btn-outline-light btn-sm">
                    <i class="mdi mdi-download me-2"></i>Download CSV
                  </button>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-striped mb-0">
                      <thead class="table-dark">
                      <tr>
                        <th>Location</th>
                        <th class="text-end">Total Plots</th>
                        <th class="text-end">Arrears B/F</th>
                        <th class="text-end">Total Billed</th>
                        <th class="text-end">Penalties</th>
                        <th class="text-end">Payments</th>
                        <th class="text-end">Balance</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in arrearsReportData" :key="item.location">
                        <td><strong>{{ item.location }}</strong></td>
                        <td class="text-end">{{ numberFormat(item.totalPlots) }}</td>
                        <td class="text-end">KES {{ numberFormat(item.totalArrears) }}</td>
                        <td class="text-end">KES {{ numberFormat(item.totalBilled) }}</td>
                        <td class="text-end">KES {{ numberFormat(item.totalPenalty) }}</td>
                        <td class="text-end">KES {{ numberFormat(item.totalPayments) }}</td>
                        <td class="text-end"><strong>KES {{ numberFormat(item.totalBalance) }}</strong></td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark" v-if="arrearsReportTotals">
                      <tr>
                        <th>GRAND TOTAL</th>
                        <th class="text-end">{{ numberFormat(arrearsReportTotals.totalPlots) }}</th>
                        <th class="text-end">KES {{ numberFormat(arrearsReportTotals.grandTotalArrears) }}</th>
                        <th class="text-end">KES {{ numberFormat(arrearsReportTotals.grandTotalBilled) }}</th>
                        <th class="text-end">KES {{ numberFormat(arrearsReportTotals.grandTotalPenalty) }}</th>
                        <th class="text-end">KES {{ numberFormat(arrearsReportTotals.grandTotalPayments) }}</th>
                        <th class="text-end"><strong>KES {{ numberFormat(arrearsReportTotals.grandTotalBalance) }}</strong></th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Loading State -->
              <div v-if="loadingArrearsReport" class="text-center py-4">
                <div class="spinner-border text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div class="mt-2">Generating report...</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Bill Annual Rent Modal -->
      <div class="modal fade bill-annual-rent-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title text-white">
                <i class="mdi mdi-calendar-clock me-2"></i>
                Bill Annual Rent
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Fiscal Year *</label>
                    <select v-model="billingForm.fiscalYear" class="form-select">
                      <option :value="currentFiscalYear">{{ currentFiscalYear }}</option>
                      <option :value="currentFiscalYear + 1">{{ currentFiscalYear + 1 }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Zone/Market</label>
                    <select v-model="billingForm.zone" class="form-select">
                      <option value="">All Zones</option>
                      <option :value="item.zone" v-for="item in zones" :key="item.zone">{{ item.zone }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="alert alert-warning">
                <h6><i class="mdi mdi-alert me-2"></i>Important Notes:</h6>
                <ul class="mb-0">
                  <li>This will bill annual rent for all <strong>Active</strong> plots in the selected zone</li>
                  <li>Plots already billed for {{ billingForm.fiscalYear }} will be <strong>skipped</strong> (idempotent)</li>
                  <li>Each plot will be billed their individual <strong>annualRent</strong> amount</li>
                </ul>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button @click="billAnnualRent" type="button" class="btn btn-primary" :disabled="processingBilling">
                <span v-if="processingBilling">
                  <span class="spinner-border spinner-border-sm me-2"></span>Processing...
                </span>
                <span v-else>
                  <i class="mdi mdi-check me-2"></i>Bill Annual Rent
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- All Modal Components -->
      <AddPlotModal
          :sub-counties="subCounties"
          :wards="wards"
          :zones="zones"
          @submit="handleAddPlot"
          @get-wards="getWards"
          @get-zones="getZonesForSubCounty"
      />

      <UploadPlotModal
          :sub-counties="subCounties"
          :wards="wards"
          :zones="zones"
          @upload-batch="handleBatchUpload"
          @upload-complete="handleUploadComplete"
          @get-zones="getZonesForSubCounty"
          @get-wards="getWards"
      />

      <UploadResultModal :uploadResult="uploadResult" />

      <PlotDetailsModal :plot="selectedPlot" />

      <EditPlotModal
          :plot="plotToEdit"
          :sub-counties="subCounties"
          :wards="wards"
          :zones="zones"
          @get-wards="getWards"
          @plot-updated="handlePlotUpdated"
      />

      <PlotTransferModal
          :plot="selectedPlot"
          @transfer-complete="handleTransferComplete"
      />

      <PlotStatusModals
          :plot="selectedPlot"
          :vacate-reasons="vacateReasons"
          @suspend-plot="confirmSuspendPlot"
          @reinstate-plot="confirmReinstatePlot"
          @vacate-plot="confirmVacatePlot"
      />

      <PlotBillingModal
          v-if="selectedPlotForBilling"
          ref="billingModal"
          :plot="selectedPlotForBilling"
          :income-types="incomeTypes"
          :fees-and-charges="feesAndCharges"
          :loading-fees="loadingFees"
          @income-type-changed="getFeesAndCharges"
          @generate-bill="handleGenerateBill"
      />

      <!-- Payment Modal (inline) -->
      <div class="modal fade" id="payment-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="paymentModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header bg-success text-white">
              <h5 class="modal-title text-white" id="paymentModalLabel">
                <i class="mdi mdi-cash-register me-2"></i>Bill Generated - Payment
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <!-- Bill Details Panel -->
              <div v-if="paymentPanel">
                <div class="text-center mb-4">
                  <div class="mb-3">
                    <i class="mdi mdi-check-circle text-success" style="font-size: 64px;"></i>
                  </div>
                  <h4 class="text-success">Bill Generated Successfully!</h4>
                  <p class="text-muted">{{ message }}</p>
                </div>

                <div class="card border-success mb-4">
                  <div class="card-header bg-success text-white">
                    <h6 class="mb-0 text-white"><i class="mdi mdi-receipt me-2"></i>Bill Details</h6>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <p class="mb-2"><strong>Bill No:</strong> {{ billDetails.billNo }}</p>
                        <p class="mb-2"><strong>Date:</strong> {{ formatDate(billDetails.dateCreated) }}</p>
                      </div>
                      <div class="col-md-6">
                        <p class="mb-2"><strong>Amount:</strong> <span class="text-success fw-bold">KES {{ numberFormat(billDetails.detailAmount) }}</span></p>
                        <p class="mb-2"><strong>Status:</strong> <span class="badge bg-warning">{{ billDetails.status }}</span></p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex gap-2 justify-content-center">
                  <button type="button" class="btn btn-outline-primary" @click="printBill">
                    <i class="mdi mdi-printer me-1"></i>Print Bill
                  </button>
                  <button type="button" class="btn btn-success d-none" @click="showPaymentMethod">
                    <i class="mdi mdi-cash me-1"></i>Make Payment
                  </button>
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </div>

              <!-- Payment Method Panel -->
              <div v-if="paymentMethod">
                <h5 class="mb-4"><i class="mdi mdi-credit-card me-2"></i>Select Payment Method</h5>

                <div class="row mb-4">
                  <div class="col-md-6 mb-3">
                    <div class="card h-100 border-success" style="cursor: pointer;" @click="selectPaymentMode('MPESA')">
                      <div class="card-body text-center">
                        <i class="mdi mdi-cellphone text-success" style="font-size: 48px;"></i>
                        <h5 class="mt-2">M-Pesa</h5>
                        <p class="text-muted small">Pay via M-Pesa STK Push</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="card h-100 border-primary" style="cursor: pointer;" @click="selectPaymentMode('BANK')">
                      <div class="card-body text-center">
                        <i class="mdi mdi-bank text-primary" style="font-size: 48px;"></i>
                        <h5 class="mt-2">Bank</h5>
                        <p class="text-muted small">Pay via Bank Transfer</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="selectedPaymentMode === 'MPESA'" class="mb-4">
                  <label class="form-label">Phone Number (M-Pesa)</label>
                  <input v-model="mpesaPhoneNumber" type="text" class="form-control" placeholder="e.g., 254712345678">
                </div>

                <div v-if="selectedPaymentMode === 'BANK'" class="mb-4">
                  <label class="form-label">Bank Receipt Number</label>
                  <input v-model="bankReceiptNo" type="text" class="form-control" placeholder="Enter bank receipt number">
                </div>

                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-secondary" @click="paymentMethod = false; paymentPanel = true;">
                    <i class="mdi mdi-arrow-left me-1"></i>Back
                  </button>
                  <button type="button" class="btn btn-success" @click="initiatePayment" :disabled="!canProceedPayment">
                    <i class="mdi mdi-cash-check me-1"></i>Proceed to Pay
                  </button>
                </div>
              </div>

              <!-- Transaction Summary Panel -->
              <div v-if="transactionSummary">
                <div class="text-center mb-4">
                  <div class="spinner-border text-success" role="status" style="width: 3rem; height: 3rem;">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <h5 class="mt-3">{{ message || 'Processing Payment...' }}</h5>
                  <p class="text-muted">Please wait while we confirm your payment</p>
                </div>

                <div class="card">
                  <div class="card-body">
                    <p><strong>Bill No:</strong> {{ billDetails.billNo }}</p>
                    <p><strong>Amount:</strong> KES {{ numberFormat(billDetails.detailAmount) }}</p>
                    <p><strong>Payment Mode:</strong> {{ selectedPaymentMode }}</p>
                  </div>
                </div>
              </div>

              <!-- Transaction Completed Panel -->
              <div v-if="transactionCompleted">
                <div class="text-center mb-4">
                  <div class="mb-3">
                    <i class="mdi mdi-check-circle text-success" style="font-size: 64px;"></i>
                  </div>
                  <h4 class="text-success">Payment Successful!</h4>
                </div>

                <div class="card border-success mb-4">
                  <div class="card-header bg-success text-white">
                    <h6 class="mb-0 text-white"><i class="mdi mdi-receipt me-2"></i>Receipt Details</h6>
                  </div>
                  <div class="card-body">
                    <p><strong>Receipt No:</strong> {{ receiptDetails.receiptNo }}</p>
                    <p><strong>Amount Paid:</strong> KES {{ numberFormat(receiptDetails.receiptAmount) }}</p>
                  </div>
                </div>

                <div class="d-flex gap-2 justify-content-center">
                  <button type="button" class="btn btn-primary" @click="printReceipt">
                    <i class="mdi mdi-printer me-1"></i>Print Receipt
                  </button>
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import moment from "moment/moment";
import { authUrl, biller, execute, executeJson, getRight, plotRent } from "@/api";
import router from "@/router";

// Import modal components
import AddPlotModal from "@/components/plotrent/modals/AddPlotModal.vue";
import UploadPlotModal from "@/components/plotrent/modals/UploadPlotModal.vue";
import UploadResultModal from "@/components/plotrent/modals/UploadResultModal.vue";
import PlotDetailsModal from "@/components/plotrent/modals/PlotDetailsModal.vue";
import EditPlotModal from "@/components/plotrent/modals/EditPlotModal.vue";
import PlotTransferModal from "@/components/plotrent/modals/PlotTransferModal.vue";
import PlotStatusModals from "@/components/plotrent/modals/PlotStatusModals.vue";
import PlotBillingModal from "@/components/plotrent/modals/PlotBillingModal.vue";

export default {
  name: "PlotRent",
  components: {
    NavigationBar,
    AddPlotModal,
    UploadPlotModal,
    UploadResultModal,
    PlotDetailsModal,
    EditPlotModal,
    PlotTransferModal,
    PlotStatusModals,
    PlotBillingModal
  },
  data() {
    return {
      // Plot data
      plots: [],
      selectedPlot: {},
      plotToEdit: {},
      selectedPlotForPayment: null,

      // Pagination
      currentPage: 1,
      totalPages: 0,
      pageSize: 25,
      loading: false,

      // Filters
      keyword: '',
      subCounty: '',
      ward: '',
      selectedZone: '',
      selectedStatus: '',
      subCountyID: '',
      subCountyName: '',
      wardID: '',
      wardName: '',

      // Dropdown data
      subCounties: [],
      wards: [],
      zones: [],
      vacateReasons: [],

      // Summary data
      summary: {
        totalPlots: 0,
        totalBalance: 0,
        totalArrears: 0,
        totalPenalty: 0,
        totalPayments: 0
      },

      // Processing states
      processingBilling: false,
      processingPenalty: false,
      processingPayment: false,
      processingStatus: null,

      // Last processing summary
      lastProcessingSummary: {
        billing: null,
        penalty: null
      },

      // Bill details (from generateBill3)
      billDetails: {
        id: '',
        billNo: '',
        incomeTypeID: '',
        incomeTypeDescription: '',
        costCenterNo: '',
        accountNo: '',
        feeID: '',
        detailAmount: '',
        receiptAmount: '',
        billBalance: '',
        wardID: '',
        subCountyID: '',
        status: '',
        dateCreated: ''
      },
      billInfo: [],

      // Payment data
      paymentData: {
        bankReceiptNo: null,
        accNo: null,
        payBillNo: null,
        amount: null,
        phoneNumber: null,
        success: false,
        paymentMode: null,
        sessionNames: null,
        sessionIdNo: null,
        sessionPhoneNumber: null
      },

      // Receipt details
      receiptDetails: {},

      // Timer for payment polling
      timer: null,

      // Payment modal states
      paymentPanel: true,
      paymentMethod: false,
      transactionSummary: false,
      transactionCompleted: false,

      // Payment mode selection
      selectedPaymentMode: '',
      mpesaPhoneNumber: '',
      bankReceiptNo: '',

      // Payment form
      paymentForm: {
        amount: 0,
        paymentMode: '',
        transactionCode: '',
        paidBy: '',
        phoneNumber: '',
        fiscalYear: new Date().getFullYear()
      },

      // Billing form
      billingForm: {
        fiscalYear: new Date().getFullYear(),
        zone: ''
      },

      // Arrears report
      arrearsReportForm: {
        reportType: 'zone',
        subCountyID: ''
      },
      arrearsReportData: null,
      arrearsReportTotals: null,
      loadingArrearsReport: false,

      // Upload result
      uploadResult: {
        successful: 0,
        failed: 0,
        totalProcessed: 0,
        message: '',
        failedRecords: []
      },

      // Billing modal data
      selectedPlotForBilling: null,
      incomeTypes: [],
      feesAndCharges: [],
      loadingFees: false,

      // Download
      isDownloadingAll: false,

      // Current fiscal year
      currentFiscalYear: new Date().getFullYear(),

      // Message
      message: null
    }
  },
  watch: {
    pageSize() {
      this.getPlots();
      this.totalPages = Math.ceil(this.summary.totalPlots / this.pageSize);
      this.currentPage = 1;
    },
    subCounty(newVal) {
      if (newVal) {
        this.subCountyID = newVal.subCountyID;
        this.subCountyName = newVal.subCountyName;
        this.getWards(newVal.subCountyID);
        this.getZonesForSubCounty(newVal.subCountyID);
      } else {
        this.subCountyID = '';
        this.subCountyName = '';
        this.wards = [];
      }
      this.getPlots();
    },
    ward(newVal) {
      if (newVal) {
        this.wardID = newVal.wardID;
        this.wardName = newVal.wardName;
      } else {
        this.wardID = '';
        this.wardName = '';
      }
      this.getPlots();
    },
    selectedZone() {
      this.getPlots();
    },
    selectedStatus() {
      this.getPlots();
    },
    keyword() {
      this.getPlots();
    }
  },
  mounted() {
    this.getPlots();
    this.getSubCounties();
    this.getAllZones();
    this.getVacateReasons();
    this.getSettings();
    this.menuAccess();
  },
  computed: {
    totalActive() {
      return this.plots.filter(p => p.status === 'Active').length;
    },
    totalSuspended() {
      return this.plots.filter(p => p.status === 'Suspended').length;
    },
    totalAnnualRent() {
      return this.plots.reduce((acc, cur) => acc + (parseFloat(cur.annualRent) || 0), 0);
    },
    totalArrears() {
      return this.plots.reduce((acc, cur) => acc + (parseFloat(cur.arrearsForward) || 0), 0);
    },
    totalBilled() {
      return this.plots.reduce((acc, cur) => acc + (parseFloat(cur.totalBilled) || 0), 0);
    },
    totalPenalty() {
      return this.plots.reduce((acc, cur) => acc + (parseFloat(cur.accumulatedPenalty) || 0), 0);
    },
    totalPayments() {
      return this.plots.reduce((acc, cur) => acc + (parseFloat(cur.totalPayments) || 0), 0);
    },
    totalBalance() {
      return this.plots.reduce((acc, cur) => acc + (parseFloat(cur.currentBalance) || 0), 0);
    },
    canProceedPayment() {
      if (this.selectedPaymentMode === 'MPESA') {
        return this.mpesaPhoneNumber && this.mpesaPhoneNumber.length >= 10;
      } else if (this.selectedPaymentMode === 'BANK') {
        return this.bankReceiptNo && this.bankReceiptNo.length > 0;
      }
      return false;
    }
  },
  methods: {
    getRight(type) {
      return getRight(type);
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Plot Rent");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).then(() => {}).catch(() => {});
    },

    // =============================================
    // PAGINATION METHODS
    // =============================================
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) end = totalPages;
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) start = 1;
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) pages.unshift("...");
      if (end < totalPages) pages.push("...");

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getPlots();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getPlots();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getPlots();
      }
    },

    // =============================================
    // FORMATTING METHODS
    // =============================================
    formatDate(date) {
      if (!date) return '-';
      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) suffix = 'st';
      else if (day % 10 === 2 && day !== 12) suffix = 'nd';
      else if (day % 10 === 3 && day !== 13) suffix = 'rd';
      else suffix = 'th';

      return `${day}${suffix} ${month} ${year}`;
    },

    numberFormat(num) {
      const formatter = new Intl.NumberFormat("en-GB");
      return formatter.format(num || 0);
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    // =============================================
    // DATA FETCHING METHODS
    // =============================================
    getPlots() {
      this.loading = true;
      this.plots = [];

      const data = new FormData();
      data.append("function", "getPlots");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("keyword", this.keyword || '');
      data.append("subCountyID", this.subCountyID || '');
      data.append("wardID", this.wardID || '');
      data.append("zone", this.selectedZone || '');
      data.append("status", this.selectedStatus || '');

      execute(data, plotRent)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.plots = res.data.data.plots || [];
              this.summary = res.data.data.summary || {};
              const count = res.data.data.count?.count || 0;
              this.totalPages = Math.ceil(count / this.pageSize);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
          });
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getWards(subCountyID) {
      this.wards = [];
      this.ward = '';

      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getAllZones() {
      const data = new FormData();
      data.append("function", "getZones");

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              this.zones = res.data.data.zones || [];
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getZonesForSubCounty(subCountyID) {
      const data = new FormData();
      data.append("function", "getZones");
      data.append("subCountyID", subCountyID);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.zones = res.data.data.zones || [];
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getVacateReasons() {
      const data = new FormData();
      data.append("function", "getVacateReasons");

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              this.vacateReasons = res.data.data.reasons || [];
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getSettings() {
      const data = new FormData();
      data.append("function", "getSettings");

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              const settings = res.data.data.settings;
              if (settings.current_fiscal_year) {
                this.currentFiscalYear = parseInt(settings.current_fiscal_year);
                this.billingForm.fiscalYear = this.currentFiscalYear;
                this.paymentForm.fiscalYear = this.currentFiscalYear;
              }
            }
          })
          .catch((e) => {
            console.error("Error fetching settings:", e);
          });
    },

    // =============================================
    // SELECTION METHODS
    // =============================================
    selectPlot(plot) {
      this.selectedPlot = plot;
    },

    selectPlotForPayment(plot) {
      this.selectedPlotForPayment = plot;
      this.paymentForm = {
        amount: plot.currentBalance || 0,
        paymentMode: '',
        transactionCode: '',
        paidBy: plot.ownerNames || '',
        phoneNumber: plot.ownerPhoneNo || '',
        fiscalYear: this.currentFiscalYear
      };
    },

    openEditModal(plot) {
      this.plotToEdit = { ...plot };
      if (plot.subCountyID) {
        this.getWards(plot.subCountyID);
      }
    },

    // =============================================
    // BILLING METHODS
    // =============================================
    showBillAnnualRentModal() {
      const modal = new bootstrap.Modal(document.querySelector('.bill-annual-rent-modal'));
      modal.show();
    },

    billAnnualRent() {
      if (!this.billingForm.fiscalYear) {
        alert("Please select a fiscal year");
        return;
      }

      const confirmMessage = `Bill annual rent for FY ${this.billingForm.fiscalYear}?\n\n` +
          `Zone: ${this.billingForm.zone || 'All Zones'}\n\n` +
          `Plots already billed for this FY will be skipped automatically.`;

      if (!confirm(confirmMessage)) return;

      this.processingBilling = true;
      this.processingStatus = {
        title: "Billing Annual Rent",
        message: `Processing FY ${this.billingForm.fiscalYear}...`
      };

      const data = new FormData();
      data.append("function", "bulkBillAnnualRent");
      data.append("fiscalYear", this.billingForm.fiscalYear);
      data.append("zone", this.billingForm.zone || '');
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, plotRent)
          .then((res) => {
            this.processingBilling = false;
            this.processingStatus = null;

            if (res.data.success) {
              const summary = res.data.data.summary;
              this.lastProcessingSummary.billing = summary;

              alert(`Annual Rent Billing Completed!\n\n` +
                  `Plots Billed: ${summary.plotsProcessed}\n` +
                  `Total Billed: KES ${this.numberFormat(summary.totalBilled)}\n` +
                  `Skipped (already billed): ${summary.skipped || 0}`);

              this.closeModal('.bill-annual-rent-modal');
              this.getPlots();
            } else {
              alert("Billing failed: " + res.data.message);
            }
          })
          .catch((e) => {
            this.processingBilling = false;
            this.processingStatus = null;
            alert("Error: " + e.message);
          });
    },

    // =============================================
    // INDIVIDUAL PLOT BILLING METHODS
    // =============================================
    openBillingModal(plot) {
      this.selectedPlotForBilling = { ...plot };
      this.feesAndCharges = [];

      // Fetch income types for plot rent
      this.getIncomeTypes();

      // Wait for DOM to update before showing modal
      this.$nextTick(() => {
        const modalEl = document.querySelector('.plot-billing-modal');
        if (modalEl) {
          const modal = new bootstrap.Modal(modalEl);
          modal.show();
        }
      });
    },

    getIncomeTypes() {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "PLTRENT");
      data.append("keyword", "Plot Rent");

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.incomeTypes = res.data.data.incomeTypes || [];
            }
          })
          .catch((e) => {
            console.error("Error fetching income types:", e);
          });
    },

    getFeesAndCharges(incomeType) {
      if (!incomeType || !incomeType.incomeTypeId) return;

      this.loadingFees = true;
      this.feesAndCharges = [];

      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", incomeType.incomeTypeId);

      execute(data, biller)
          .then((res) => {
            this.loadingFees = false;
            if (res.data.success) {
              this.feesAndCharges = res.data.data.feesAndCharges || [];
            }
          })
          .catch((e) => {
            this.loadingFees = false;
            console.error("Error fetching fees:", e);
          });
    },

    handleGenerateBill(billingData) {
      // Build billItem array following Land Rates pattern
      const billItem = [{
        feeId: billingData.feeId,
        feeDescription: billingData.feeDescription,
        unitFeeAmount: billingData.amount,
        accountNo: billingData.accountNo || '',
        costCenterNo: billingData.costCenterNo || '',
        incomeTypeId: billingData.incomeTypeId,
        revenueStreamItem: billingData.plotNumber,
        amount: billingData.amount,
        customer: billingData.plotID,
        zone: billingData.zone,
        subCountyID: billingData.subCountyID,
        subCountyName: billingData.subCountyName,
        wardID: billingData.wardID,
        wardName: billingData.wardName,
        idNo: sessionStorage.getItem("sessionIdNo"),
        phoneNumber: sessionStorage.getItem("sessionPhoneNumber"),
        names: sessionStorage.getItem("sessionNames"),
        customerPhoneNumber: billingData.ownerPhoneNo || '',
        description: `Plot No.: ${billingData.plotNumber} | Zone: ${billingData.zone} | Name: ${billingData.ownerNames} | CHARGES - Annual Rent: KES ${this.numberFormat(billingData.annualRent || 0)}, Current Balance: KES ${this.numberFormat(billingData.balanceBefore)}`,
        customerName: `${billingData.plotNumber} | ${billingData.ownerNames}`
      }];

      const data = new FormData();
      data.append("function", "generateBill3");
      data.append("billItem", JSON.stringify(billItem));
      data.append("customerPhoneNumber", billingData.ownerPhoneNo || '');
      data.append("messageCode", "BLL");
      data.append("names", billingData.ownerNames);
      data.append("email", billingData.ownerEmail || '');

      execute(data, biller)
          .then((res) => {
            // Reset the modal generating state
            const billingModal = this.$refs.billingModal;
            if (billingModal) billingModal.stopGenerating();

            if (res.data.success) {
              // Store bill details for payment modal
              this.billDetails = res.data.data.bill.billDetails;
              this.billInfo = res.data.data.bill.billInfo;

              // Setup payment data
              this.paymentData.amount = res.data.data.bill.billDetails.billBalance;
              this.paymentData.accNo = res.data.data.bill.billDetails.billNo;
              this.paymentData.payBillNo = res.data.data.billGenerated.payBillNo;
              this.paymentData.sessionNames = sessionStorage.getItem("sessionNames");
              this.paymentData.sessionIdNo = sessionStorage.getItem("sessionIdNo");
              this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber");

              // Reset payment modal states
              this.paymentPanel = true;
              this.paymentMethod = false;
              this.transactionSummary = false;
              this.transactionCompleted = false;
              this.message = "Bill generated successfully!";

              // Close the billing modal
              this.closeModal('.plot-billing-modal');

              // Open payment modal
              this.$nextTick(() => {
                const paymentModal = document.querySelector('#payment-modal');
                if (paymentModal) {
                  const modalInstance = new bootstrap.Modal(paymentModal);
                  modalInstance.show();
                }
              });

              // Refresh plots list
              this.getPlots();
              this.selectedPlotForBilling = null;
            } else {
              alert("Billing failed: " + res.data.message);
            }
          })
          .catch((e) => {
            const billingModal = this.$refs.billingModal;
            if (billingModal) billingModal.stopGenerating();
            alert("Error: " + e.message);
          });
    },

    // =============================================
    // PAYMENT MODAL METHODS (for bill payment flow)
    // =============================================
    printBill() {
      if (!this.billDetails || !this.billDetails.billNo) {
        alert("No bill to print");
        return;
      }
      localStorage['params'] = JSON.stringify({
        billNo: this.billDetails.billNo
      });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    showPaymentMethod() {
      this.selectedPaymentMode = '';
      this.mpesaPhoneNumber = '';
      this.bankReceiptNo = '';
      this.paymentMethod = true;
      this.paymentPanel = false;
      this.transactionSummary = false;
      this.transactionCompleted = false;
    },

    selectPaymentMode(mode) {
      this.selectedPaymentMode = mode;
      // Pre-fill phone number from session if available
      if (mode === 'MPESA') {
        this.mpesaPhoneNumber = sessionStorage.getItem("sessionPhoneNumber") || '';
      }
    },

    initiatePayment() {
      if (this.selectedPaymentMode === 'MPESA' && !this.mpesaPhoneNumber) {
        alert("Please enter phone number");
        return;
      }
      if (this.selectedPaymentMode === 'BANK' && !this.bankReceiptNo) {
        alert("Please enter bank receipt number");
        return;
      }

      // Setup payment data
      this.paymentData.paymentMode = this.selectedPaymentMode;
      this.paymentData.phoneNumber = this.mpesaPhoneNumber;
      this.paymentData.bankReceiptNo = this.bankReceiptNo;

      // Show transaction summary / processing
      this.paymentMethod = false;
      this.paymentPanel = false;
      this.transactionSummary = true;
      this.transactionCompleted = false;
      this.message = "Payment Request sent...";

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(this.paymentData));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              // Start polling for payment status
              this.timer = setInterval(() => {
                this.checkPaymentStatus();
              }, 3000);
            } else {
              alert(res.data.message);
              this.paymentMethod = true;
              this.transactionSummary = false;
            }
          })
          .catch((e) => {
            alert(e.message);
            this.paymentMethod = true;
            this.transactionSummary = false;
          });
    },

    showTransactionSummary(paymentInfo) {
      this.paymentData.paymentMode = paymentInfo.paymentMode;
      this.paymentData.phoneNumber = paymentInfo.phoneNumber;
      this.paymentData.bankReceiptNo = paymentInfo.bankReceiptNo;

      this.paymentMethod = false;
      this.paymentPanel = false;
      this.transactionSummary = true;
      this.transactionCompleted = false;
    },

    makePaymentFromBill(paymentInfo) {
      this.message = "Payment Request sent";
      this.paymentData.phoneNumber = paymentInfo.phoneNumber;
      this.paymentData.paymentMode = paymentInfo.paymentMode;
      this.paymentData.bankReceiptNo = paymentInfo.bankReceiptNo;

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(this.paymentData));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.paymentMethod = false;
              this.paymentPanel = false;
              this.timer = setInterval(() => {
                this.checkPaymentStatus();
              }, 3000);
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    checkPaymentStatus() {
      const randomNumber = Math.floor(Math.random() * 3) + 1;
      if (randomNumber === 1) {
        this.message = "Waiting for payment.";
      } else if (randomNumber === 2) {
        this.message = "Waiting for payment..";
      } else {
        this.message = "Waiting for payment...";
      }

      const data = new FormData();
      data.append("function", "checkPayment");
      data.append("accountRef", this.paymentData.accNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.message = null;
              clearInterval(this.timer);
              this.paymentData.success = false;
              this.receiptDetails = res.data.data.receipt.receiptDetails;
              this.transactionSummary = false;
              this.transactionCompleted = true;

              // Refresh plots list
              this.getPlots();
            }
          })
          .catch((e) => {
            console.error("Check payment error:", e);
          });
    },

    printReceipt() {
      if (!this.receiptDetails || !this.receiptDetails.receiptNo) {
        alert("Receipt not available. Try again later.");
        return;
      }
      localStorage['params'] = JSON.stringify({
        receiptNo: this.receiptDetails.receiptNo
      });
      const routeData = this.$router.resolve({ name: 'receipt' });
      window.open(routeData.href, '_blank');
    },

    // =============================================
    // PENALTY METHODS
    // =============================================
    calculateAnnualPenalty() {
      if (this.processingPenalty) {
        alert("Penalty calculation is already in progress.");
        return;
      }

      const confirmMessage = `Calculate 25% annual penalty on all plots with arrears?\n\n` +
          `This will apply penalties for FY ${this.currentFiscalYear}.\n\n` +
          `Plots already processed this fiscal year will be skipped.`;

      if (!confirm(confirmMessage)) return;

      this.processingPenalty = true;
      this.processingStatus = {
        title: "Calculating Annual Penalty",
        message: "Applying 25% penalty on arrears..."
      };

      const data = new FormData();
      data.append("function", "bulkApplyPenalty");
      data.append("fiscalYear", this.currentFiscalYear.toString());
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, plotRent)
          .then((res) => {
            this.processingPenalty = false;
            this.processingStatus = null;

            if (res.data.success) {
              const summary = res.data.data.summary;
              this.lastProcessingSummary.penalty = summary;

              alert(`Annual Penalty Calculation Completed!\n\n` +
                  `Plots Processed: ${summary.plotsProcessed}\n` +
                  `Total Penalty Applied: KES ${this.numberFormat(summary.totalPenaltyApplied)}\n` +
                  `Skipped: ${summary.skipped || 0}`);

              this.getPlots();
            } else {
              alert("Penalty calculation failed: " + res.data.message);
            }
          })
          .catch((e) => {
            this.processingPenalty = false;
            this.processingStatus = null;
            alert("Error: " + e.message);
          });
    },

    // =============================================
    // PAYMENT METHODS
    // =============================================
    processPayment() {
      if (!this.paymentForm.amount || this.paymentForm.amount <= 0) {
        alert("Please enter a valid payment amount");
        return;
      }

      if (!this.paymentForm.paymentMode) {
        alert("Please select payment mode");
        return;
      }

      if (!this.selectedPlotForPayment) {
        alert("No plot selected for payment");
        return;
      }

      const confirmMessage = `Confirm payment processing:\n\n` +
          `Plot: ${this.selectedPlotForPayment.plotNumber}\n` +
          `Amount: KES ${this.numberFormat(this.paymentForm.amount)}\n` +
          `Payment Mode: ${this.paymentForm.paymentMode}\n\n` +
          `Payment will be allocated to oldest arrears first.`;

      if (!confirm(confirmMessage)) return;

      this.processingPayment = true;

      const data = new FormData();
      data.append("function", "recordPayment");
      data.append("plotID", this.selectedPlotForPayment.id);
      data.append("plotNumber", this.selectedPlotForPayment.plotNumber);
      data.append("zone", this.selectedPlotForPayment.zone);
      data.append("amount", this.paymentForm.amount.toString());
      data.append("paymentMode", this.paymentForm.paymentMode);
      data.append("transactionCode", this.paymentForm.transactionCode || '');
      data.append("paidBy", this.paymentForm.paidBy || '');
      data.append("phoneNumber", this.paymentForm.phoneNumber || '');
      data.append("fiscalYear", this.paymentForm.fiscalYear.toString());
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, plotRent)
          .then((res) => {
            this.processingPayment = false;

            if (res.data.success) {
              // API returns data directly, not nested in paymentSummary
              const paymentData = res.data.data || {};

              alert(`Payment Processed Successfully!\n\n` +
                  `Amount Paid: KES ${this.numberFormat(paymentData.amount || this.paymentForm.amount)}\n` +
                  `New Balance: KES ${this.numberFormat(paymentData.balanceAfter)}\n` +
                  `Receipt No: ${paymentData.receiptNo || 'N/A'}`);

              this.closeModal('.payment-processing-modal');
              this.getPlots();
              this.selectedPlotForPayment = null;
            } else {
              alert("Payment failed: " + res.data.message);
            }
          })
          .catch((e) => {
            this.processingPayment = false;
            alert("Error: " + e.message);
          });
    },

    // =============================================
    // ARREARS REPORT METHODS
    // =============================================
    generateArrearsReport() {
      this.loadingArrearsReport = true;
      this.arrearsReportData = null;
      this.arrearsReportTotals = null;

      const data = new FormData();
      data.append("function", "getZones");
      data.append("subCountyID", this.arrearsReportForm.subCountyID || '');

      execute(data, plotRent)
          .then((res) => {
            this.loadingArrearsReport = false;

            if (res.data.success) {
              this.arrearsReportData = res.data.data.zones || [];

              // Calculate totals
              let totals = {
                totalPlots: 0,
                grandTotalArrears: 0,
                grandTotalBilled: 0,
                grandTotalPenalty: 0,
                grandTotalPayments: 0,
                grandTotalBalance: 0
              };

              this.arrearsReportData.forEach(item => {
                totals.totalPlots += parseInt(item.totalPlots) || 0;
                totals.grandTotalArrears += parseFloat(item.totalArrears) || 0;
                totals.grandTotalBilled += parseFloat(item.totalBilled) || 0;
                totals.grandTotalPenalty += parseFloat(item.totalPenalty) || 0;
                totals.grandTotalPayments += parseFloat(item.totalPayments) || 0;
                totals.grandTotalBalance += parseFloat(item.totalBalance) || 0;
              });

              this.arrearsReportTotals = totals;
            } else {
              alert("Error generating report: " + res.data.message);
            }
          })
          .catch((e) => {
            this.loadingArrearsReport = false;
            alert("Error: " + e.message);
          });
    },

    downloadArrearsReport() {
      if (!this.arrearsReportData || this.arrearsReportData.length === 0) {
        alert("No data to download");
        return;
      }

      const headers = ['Location', 'Total Plots', 'Arrears B/F', 'Total Billed', 'Penalties', 'Payments', 'Balance'];
      const csvData = this.arrearsReportData.map(item => [
        item.location || item.zone,
        item.totalPlots || 0,
        item.totalArrears || 0,
        item.totalBilled || 0,
        item.totalPenalty || 0,
        item.totalPayments || 0,
        item.totalBalance || 0
      ]);

      const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `Plot_Rent_Arrears_Report_${moment().format('YYYY-MM-DD')}.csv`;
      link.click();
    },

    // =============================================
    // CRUD OPERATIONS
    // =============================================
    handleAddPlot(plotData) {
      plotData.createdBy = sessionStorage.getItem("sessionNames");
      plotData.createdByIDNo = sessionStorage.getItem("sessionIdNo");

      const data = {
        ...plotData,
        function: "addPlot"
      };

      executeJson(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              alert(res.data.message);
              this.getPlots();
              this.closeModal('.add-plot-modal');
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert("Error: " + e.message);
          });
    },

    handlePlotUpdated() {
      this.getPlots();
    },

    deletePlot(plot) {
      if (!confirm(`Are you sure you want to delete plot '${plot.plotNumber}'?`)) return;

      const data = new FormData();
      data.append("function", "deletePlot");
      data.append("id", plot.id);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              alert(res.data.message);
              this.getPlots();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert("Error: " + e.message);
          });
    },

    // =============================================
    // STATUS CHANGE METHODS
    // =============================================
    handleSuspendPlot(plot) {
      this.selectedPlot = plot;
    },

    handleReinstatePlot(plot) {
      this.selectedPlot = plot;
    },

    handleVacatePlot(plot) {
      this.selectedPlot = plot;
    },

    confirmSuspendPlot(formData) {
      const data = new FormData();
      data.append("function", "updatePlot");
      data.append("id", formData.plot.id);
      data.append("status", "Suspended");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              alert("Plot suspended successfully");
              this.getPlots();
              this.closeModal('.suspend-modal');
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert("Error: " + e.message);
          });
    },

    confirmReinstatePlot(formData) {
      const data = new FormData();
      data.append("function", "updatePlot");
      data.append("id", formData.plot.id);
      data.append("status", "Active");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              alert("Plot reinstated successfully");
              this.getPlots();
              this.closeModal('.reinstate-modal');
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert("Error: " + e.message);
          });
    },

    confirmVacatePlot(formData) {
      const data = new FormData();
      data.append("function", "updatePlot");
      data.append("id", formData.plot.id);
      data.append("status", "Vacant");
      data.append("ownerNames", "");
      data.append("ownerPhoneNo", "");
      data.append("ownerEmail", "");
      data.append("ownerID", "");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              alert("Plot marked as vacant successfully");
              this.getPlots();
              this.closeModal('.vacate-modal');
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert("Error: " + e.message);
          });
    },

    handleTransferComplete() {
      this.getPlots();
    },

    // =============================================
    // UPLOAD METHODS
    // =============================================
    handleBatchUpload(batchPayload, callback) {
      const enhancedBatch = batchPayload.plotData.map(row => ({
        ...row,
        createdBy: sessionStorage.getItem("sessionNames"),
        createdByIDNo: sessionStorage.getItem("sessionIdNo"),
        status: 'Active'
      }));

      const jsonPayload = {
        function: "uploadPlots",
        plotData: enhancedBatch,
        uploadMetadata: batchPayload.uploadMetadata
      };

      executeJson(jsonPayload, plotRent)
          .then((res) => {
            // Safely access nested data
            const responseData = res?.data?.data || {};

            if (res?.data?.success) {
              callback({
                success: true,
                data: {
                  successful: responseData.successful || 0,
                  failed: responseData.failed || 0,
                  failedRecords: responseData.failedRecords || []
                }
              });
            } else {
              callback({
                success: false,
                message: res?.data?.message || 'Upload failed',
                data: {
                  successful: 0,
                  failed: enhancedBatch.length,
                  failedRecords: []
                }
              });
            }
          })
          .catch((e) => {
            console.error('Batch upload error:', e);
            callback({
              success: false,
              message: e.message || 'Network error',
              data: { successful: 0, failed: enhancedBatch.length, failedRecords: [] }
            });
          });
    },

    handleUploadComplete(finalResults) {
      this.uploadResult = {
        successful: finalResults?.successful || 0,
        failed: finalResults?.failed || 0,
        totalProcessed: finalResults?.totalProcessed || 0,
        message: finalResults?.message || 'Upload completed',
        failedRecords: finalResults?.failedRecords || []
      };

      try {
        const resultModalEl = document.querySelector('.upload-result-modal');
        if (resultModalEl) {
          const resultModal = new bootstrap.Modal(resultModalEl);
          resultModal.show();
        }
      } catch (e) {
        console.error('Error showing result modal:', e);
      }

      if (finalResults?.successful > 0) {
        this.getPlots();
      }

      this.closeModal('.upload-plot-modal');
    },

    // =============================================
    // DOWNLOAD METHODS
    // =============================================
    downloadCurrentPage() {
      if (this.plots.length === 0) {
        alert('No data to download');
        return;
      }

      const csv = this.generateCSV(this.plots);
      this.downloadCSV(csv, `Plot_Rent_Page_${this.currentPage}_${moment().format('YYYY-MM-DD')}.csv`);
    },

    downloadAllRecords() {
      alert("Download all feature - implement with pagination like Land Rates");
    },

    generateCSV(data) {
      const headers = [
        'Plot Number', 'Zone', 'Owner Names', 'Phone', 'ID Number',
        'Sub County', 'Ward', 'Annual Rent', 'Arrears B/F', 'Total Billed',
        'Penalty', 'Payments', 'Balance', 'Status'
      ];

      let csv = headers.join(',') + '\n';

      data.forEach(item => {
        const row = [
          this.escapeCSV(item.plotNumber),
          this.escapeCSV(item.zone),
          this.escapeCSV(item.ownerNames),
          this.escapeCSV(item.ownerPhoneNo),
          this.escapeCSV(item.ownerID),
          this.escapeCSV(item.subCountyName),
          this.escapeCSV(item.wardName),
          item.annualRent || 0,
          item.arrearsForward || 0,
          item.totalBilled || 0,
          item.accumulatedPenalty || 0,
          item.totalPayments || 0,
          item.currentBalance || 0,
          item.status || 'Active'
        ];
        csv += row.join(',') + '\n';
      });

      return csv;
    },

    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const str = String(value);
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return '"' + str.replace(/"/g, '""') + '"';
      }
      return str;
    },

    downloadCSV(content, filename) {
      const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },

    // =============================================
    // NAVIGATION METHODS
    // =============================================
    goToStatements(plot) {
      sessionStorage.setItem("plotID", plot.id);
      sessionStorage.setItem("plotNumber", plot.plotNumber);
      sessionStorage.setItem("plotZone", plot.zone);
      router.push('plot-statements');
    },

    // =============================================
    // UTILITY METHODS
    // =============================================
    closeModal(selector) {
      try {
        const modal = document.querySelector(selector);
        if (modal) {
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) {
            modalInstance.hide();
          }
        }
      } catch (error) {
        console.error('Error closing modal:', error);
      }
    }
  }
}
</script>

<style scoped>
.fs-6 {
  font-size: 0.875rem;
}

.small {
  font-size: 0.75rem;
}

.text-end {
  text-align: right;
}

.badge {
  font-size: 0.75em;
}

.table td {
  vertical-align: middle;
}

.table-responsive {
  font-size: 0.9rem;
}

.btn-sm {
  font-size: 0.8rem;
}

.dropdown-menu {
  border: none;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-radius: 8px;
}

.dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
  color: #28a745;
  transform: translateX(4px);
}

.dropdown-item i {
  width: 20px;
  text-align: center;
}
</style>